/**
 * A/B do preço no começo do cadastro — signup-price-notice-2026-10 (front).
 *
 * Auditoria UX de 24/10/2026: quem chega pelo anúncio toca no botão da promo
 * em ~5 s, sem passar pelo preço, faz ~7 min de triagem e só vê os R$ 79,90
 * no paywall. Das cobranças geradas no paywall, as do anúncio pagam 38–43%;
 * as sem anúncio, 74–88%.
 *
 *   control       tela do nome como antes, sem preço.
 *   price_shown   uma linha com o preço abaixo do título da tela do nome.
 *
 * O sorteio é por aparelho, na primeira vez que a tela do nome aparece: quem
 * vem do anúncio abre /consulta direto no .app, e o patientId só nasce na
 * confirmação do nome. O braço vai em todo evento de telemetria
 * (`price_notice_arm`), do nome até o pagamento.
 *
 * Fica fora (null, sem linha): kill switch desligado, domínio .org e cupom de
 * link capturado, porque o paywall mostraria outro valor.
 *
 * `SIGNUP_PRICE_NOTICE_AB_LIVE = false` devolve todo mundo ao controle.
 * Preview: `?price_notice=price_shown|control` força o braço na sessão.
 */

import { isOrgHost } from '../lib/siteHosts';
import { readUrlCoupon } from '../lib/urlCoupon';

export const PRICE_NOTICE_CONTROL = 'control';
export const PRICE_NOTICE_SHOWN = 'price_shown';
export const PRICE_NOTICE_ARMS = [PRICE_NOTICE_CONTROL, PRICE_NOTICE_SHOWN];

export const SIGNUP_PRICE_NOTICE_AB_LIVE = true;

/** Preço de tabela do paywall (`catalogPriceCents`) e da FAQ da Home. Mudar junto. */
export const SIGNUP_PRICE_LABEL = 'R$ 79,90';

const STORAGE_KEY = 'signupPriceNoticeArm';
const PREVIEW_KEY = 'signupPriceNoticePreview';

function previewOverride() {
  try {
    if (typeof window === 'undefined') return null;
    const q = new URLSearchParams(window.location.search).get('price_notice');
    if (PRICE_NOTICE_ARMS.includes(q)) {
      sessionStorage.setItem(PREVIEW_KEY, q);
      return q;
    }
    const stored = sessionStorage.getItem(PREVIEW_KEY);
    if (PRICE_NOTICE_ARMS.includes(stored)) return stored;
  } catch {}
  return null;
}

function isEligible() {
  if (!SIGNUP_PRICE_NOTICE_AB_LIVE) return false;
  try {
    if (isOrgHost()) return false;
  } catch {}
  return !readUrlCoupon();
}

function readStoredArm() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    return parsed && PRICE_NOTICE_ARMS.includes(parsed.arm) ? parsed.arm : null;
  } catch {
    return null;
  }
}

/**
 * Braço já sorteado neste aparelho, ou null quando ele está fora do
 * experimento. Não sorteia: a telemetria lê isto em todo evento, e quem nunca
 * viu a tela do nome não pode entrar na amostra.
 */
export function getSignupPriceNoticeArmRaw() {
  const preview = previewOverride();
  if (preview) return preview;
  if (!isEligible()) return null;
  return readStoredArm();
}

/** Sorteia na primeira exibição da tela do nome e mantém o braço no aparelho. */
export function assignSignupPriceNoticeArm(random = Math.random) {
  const preview = previewOverride();
  if (preview) return preview;
  if (!isEligible()) return null;
  const stored = readStoredArm();
  if (stored) return stored;
  const arm = random() < 0.5 ? PRICE_NOTICE_CONTROL : PRICE_NOTICE_SHOWN;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ arm, assignedAtMs: Date.now() }));
  } catch {
    return null;
  }
  return arm;
}

export function showsSignupPriceNotice(arm) {
  return arm === PRICE_NOTICE_SHOWN;
}
